import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { formatDate, formatOverflow, formatComment, formatNull, isDatePastInMoscow } from '../../Utils/GlobalUtils';

import headerPanel from '../../styles/HeaderPanel.module.css';

import Modal from '../Modal';
import ListMailing from '../CaseComponents/Modals/ListMailing';
import AttachAM from '../CaseComponents/Modals/AttachAM';
import SearchProposedCases from '../SearchModals/SearchProposedCases';
import FilterProposedCases from '../FilterComponents/FilterProposedCases';

import Loading from '../../Components/Loading';
import LoadingLines from '../../Components/LoadingLines';
import WarningPanel from '../../Components/WarningPanel';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';
import { ReactComponent as FunnelIcon } from '../../icons/funnel-bold.svg';
import { ReactComponent as FunnelFillIcon } from '../../icons/funnel-fill.svg';

const WorkerProposedCases = () => {
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [reload, setReload] = React.useState(true);

    const [limitForView, setLimitForView] = React.useState(50);
    const [lastUpdateTime, setLastUpdateTime] = React.useState('');

    const DEFAULT_FILTERS = {
        numbers: [],
        debtors: [],
        category: '',
        date_mailing_from: '',
        date_mailing_to: '',
        date_consent_deadline_from: '',
        date_consent_deadline_to: '',
        count_pretenders: [],
        mailing_status: '',
        user_status: '',
    };

    const STORAGE_KEY = 'proposedcasesworker_filters';

    const [filters, setFilters] = React.useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? { ...DEFAULT_FILTERS, ...JSON.parse(saved) } : DEFAULT_FILTERS;
        } catch {
            return DEFAULT_FILTERS;
        }
    });

    React.useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
    }, [filters]);

    const hasActiveFilters = Object.entries(filters).some(([key, value]) => 
        Array.isArray(value) ? value.length > 0 : Boolean(value)
    );

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);

        if (!hasActiveFilters) {
            axios.get(`/api/get-all-proposed-cases?limitForView=${limitForView}`, {
                headers: { 
                    Authorization: `Bearer ${token}` 
                }
            }).then((response) => {
                setWarning('');
                setCases(response.data);
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setReload(false);
                setLoading(false);
                setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
            });
        } else {
            axios.post('/api/get-all-proposed-cases-filtered', filters, {
                headers: { 
                    Authorization: `Bearer ${token}` 
                },
                params: { 
                    limitForView 
                },
            })
            .then((response) => {
                setWarning('');
                setCases(response.data);
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setReload(false);
                setLoading(false);
                setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
            });
        }
    }, [reload]);

    const [isAttachAM, setIsAttachAM] = React.useState(false);
    const [stepAttachAM, setStepAttachAM] = React.useState('');
    const [isListMailing, setIsListMailing] = React.useState(false);
    const [currentCaseId, setCurrentCaseId] = React.useState('');

    const openAttachAM = (step) => {
        setIsAttachAM(true);
        setIsListMailing(false);
        setStepAttachAM(step);
    };
    const openListMailing = () => {
        setIsAttachAM(false);
        setIsListMailing(true);
    };

    const [isSearch, setIsSearch] = React.useState(false);

    React.useEffect(() => {
        if (window.location.hash === '#search') {
            setIsSearch(true);
        }
    }, []);

    const [isFilter, setIsFilter] = React.useState(false);
    const [fieldFilter, setFieldFilter] = React.useState(null);

    React.useEffect(() => {
        if (window.location.hash === '#filter') {
            setIsFilter(true);
        }
    }, []);

    
    return (
    <>
        <Modal isOpen={isAttachAM} closeModal={() => { window.location.hash = ''; setIsAttachAM(false) }}>
            <AttachAM caseId={currentCaseId} caseNumber={currentCaseId} step={stepAttachAM} openListMailing={openListMailing} onSuccess={() => setReload(true)} />
        </Modal>
        <Modal isOpen={isListMailing} closeModal={() => { window.location.hash = ''; setIsListMailing(false) }}>
            <ListMailing caseId={currentCaseId} openAttachAM={openAttachAM} onSuccess={() => setReload(true)} />
        </Modal>
        <Modal isOpen={isSearch} closeModal={() => { window.location.hash = ''; setIsSearch(false) }}>
            <SearchProposedCases />
        </Modal>
        <Modal isOpen={isFilter} closeModal={() => { setIsFilter(false); setFieldFilter('all'); setReload(true) }}>
            <FilterProposedCases field={fieldFilter} filters={filters} setFilters={setFilters} DEFAULT_FILTERS={DEFAULT_FILTERS} />
        </Modal>

        <div className={headerPanel.panel}>
            <div className={headerPanel.searchBtn} onClick={() => { window.location.hash = 'search'; setIsSearch(true) }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
                Поиск...
            </div>
        </div>

        {/* <ToolBar onSearch={() => { window.location.hash = 'search'; setIsSearch(true) }} /> */}
      
        <div className='pageWrapper'>
            <div className='tableContainer'>
                <div className='tableHeaderWrapper'>
                    <div className='tableStatus'>
                        <div>
                            {hasActiveFilters && 
                            <span className='horizontalContainer'>
                                <p>Применены фильтры</p>
                                <p 
                                    className='aWithLink'
                                    onClick={() => {setFilters(DEFAULT_FILTERS); setReload(true)}}
                                >
                                    Сбросить
                                </p>
                            </span>
                            }
                        </div>
                        <a className='lastUpdateWrapper'>
                            Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                            {loading ? 
                                <Loading type='inline' /> 
                            : 
                                <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                            }
                        </a>
                    </div>
                    <div className='tableHeader' style={{gridTemplateColumns: '10fr 10fr 17fr 10fr 10fr 11fr 17fr 15fr'}}>
                        <div>
                            <p>Номер</p>
                            <IconContainer 
                                Icon={filters.numbers.length > 0 ? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('numbers');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${filters.numbers.length > 0 && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div>
                            <p>Процедура / Должники</p>
                            <IconContainer 
                                Icon={(filters.debtors.length > 0 || filters.category) ? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('debtors');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${(filters.debtors.length > 0 || filters.category) && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div>Последнее сообщение</div>
                        <div>
                            <p>Дата рассылки предложения</p>
                            <IconContainer 
                                Icon={filters.date_mailing_from.length > 0? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('date_mailing');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${filters.date_mailing_from.length > 0 && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div>
                            <p>Крайний срок предоставления согласия</p>
                            <IconContainer 
                                Icon={filters.date_consent_deadline_from.length > 0 ? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('date_consent_deadline');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${filters.date_consent_deadline_from.length > 0 && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div>
                            <p>Количество претендующих</p>
                            <IconContainer 
                                Icon={filters.count_pretenders.length > 0 ? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('count_pretenders');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${filters.count_pretenders.length > 0 && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div>
                            <p>Статус</p>
                            <IconContainer 
                                Icon={(filters.mailing_status.length > 0 || filters.user_status) ? FunnelFillIcon : FunnelIcon} 
                                onClick={() => {
                                    setIsFilter(true);
                                    setFieldFilter('mailing_status');
                                }} 
                                size = '15' 
                                color = 'black' 
                                className = {`
                                    ${'filterHeaderIcon'} 
                                    ${(filters.mailing_status.length > 0 || filters.user_status) && 'showedFilterHeaderIcon'}
                                `}
                            />
                        </div>
                        <div></div>
                    </div>
                </div>
                {(cases.length===0 && loading) ? <LoadingLines /> 
                : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
                : cases.map((caseItem, index) => (
                    <motion.div
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        exit={{ scale: '97%', opacity: 0 }}
                        transition={{ duration: 0.3 }}

                        className='tableRow nonActive' 
                        key={index} 
                        style={{gridTemplateColumns: '10fr 10fr 17fr 10fr 10fr 11fr 17fr 15fr'}}
                    >
                        <div>
                            <span className='horizontalContainer'>
                            <Link
                                className='aWithLink' 
                                to={`/case/${caseItem.id}`}
                            >
                                {formatNull(caseItem.number)}
                            </Link>
                            {/* <SideViewForCase caseId={caseItem.id} /> */}
                            </span>
                        </div>
                        <div>
                            <p
                                className='grayText'
                            >
                                {formatNull(caseItem.procedure_name)}
                            </p>
                            <span className='horizontalLine'></span>
                            <p>
                                {caseItem.debtors ?
                                    <p>
                                        {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                                    </p>
                                    :
                                    formatNull(caseItem.debtors)
                                }
                            </p>
                        </div>
                        <div>{formatComment(caseItem.first_comment)}</div>
                        <div>{caseItem.mailing_status==='Письма не отправлены' ? <p>Письма не отправлены</p> : formatDate(caseItem.date_mailing)}</div>
                        <div>
                            <p>{formatDate(caseItem.date_consent_deadline)}</p>
                        </div>
                        <div>
                            <p>{caseItem.count_pretenders}</p>
                        </div>
                        <div>
                            {(caseItem.user_id!=='' && caseItem.user_id!==null) ? <p className='colorCell green'>Кандидатура выбрана СРО ({caseItem.am?.lastname} {caseItem.am?.firstname} {caseItem.am?.surname} {caseItem.am?.email})</p>
                            :
                            (caseItem.mailing_status=='Письма отправлены' && isDatePastInMoscow(caseItem.date_end_mailing)) 
                            ? <p className='colorCell red'>Рассылка совершена [Срок предоставления согласий прошел]</p>
                            : caseItem.mailing_status=='Письма отправлены' ? <p>Рассылка совершена</p>
                            : <p className='colorCell blue'>Совершите рассылку</p>}
                        </div>
                        <div>
                            {(caseItem.mailing_status==='Письма не отправлены' && !caseItem.user_id) ?
                            <button 
                                type='button' 
                                className='miniButton'
                                onClick={() => {setIsAttachAM(true); setCurrentCaseId(caseItem.id)}}
                            >
                                Перейти к рассылке
                            </button>
                            : caseItem.mailing_status=='Письма отправлены' ?
                            <button 
                                type='button' 
                                className='miniButton'
                                onClick={() => {setIsListMailing(true); setCurrentCaseId(caseItem.id)}}
                            >
                                Просмотреть информацию по рассылке
                            </button>
                            : null}
                        </div>
                    </motion.div>
                ))}
                {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
                    <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                        <div></div>
                        <div>
                            <button
                                type='button'
                                className='button'
                                style={{ width: 'fit-content' }}
                                onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                                disabled={loading}
                            >
                                {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                            </button>
                        </div>
                        <div></div>
                    </div>
                )}
            </div>
        </div>
    </>
    )
}

export default WorkerProposedCases;